import { render, staticRenderFns } from "./Contact1.vue?vue&type=template&id=4efe7516"
import script from "./Contact1.vue?vue&type=script&lang=js"
export * from "./Contact1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports